import dkAxios from '@/jslib/dk-axios'

export const Statistics = data => dkAxios({
  url: '/cms/Statistics/total',
  method: 'POST',
  data,
});

export const StatisticsEchart = data => dkAxios({
  url: '/cms/Statistics',
  method: 'GET',
  params: data,
});



// WEBPACK FOOTER //
// ./src/api/statistics.js